/**
 * Browser settings types.
 * Mirrors backend models.py BrowserSettings and the RTDB node
 * devices/{id}/config/browserSettings (see contracts/firebase-schema.md §2.6).
 *
 * allowUrlEntry: when false the tablet's Browser hides the URL field, Go, Clear and the
 * history drop-down. Absent node / absent key = true.
 */

export interface BrowserSettings {
  allowUrlEntry: boolean;
  updatedAt?: number | null;
  updatedBy?: string | null;
}

export type BrowserSettingsUpdate = Partial<Pick<BrowserSettings, 'allowUrlEntry'>>;

export const DEFAULT_BROWSER_SETTINGS: BrowserSettings = {
  allowUrlEntry: true,
};
